import {
  endOfDay,
  endOfMonth,
  endOfYear,
  startOfDay,
  startOfMonth,
  startOfYear,
  subDays,
  subMonths,
  subYears,
} from "date-fns";

import { RelativeDateRange } from "@/types/enums.ts";

const relativeDateLookup: Record<RelativeDateRange, [Date, Date]> = {
  [RelativeDateRange.TODAY]: [startOfDay(new Date()), endOfDay(new Date())],
  [RelativeDateRange.LAST_MONTH]: [
    startOfMonth(subMonths(new Date(), 1)),
    endOfMonth(subMonths(new Date(), 1)),
  ],
  [RelativeDateRange.THIS_MONTH]: [
    startOfMonth(new Date()),
    endOfDay(new Date()),
  ],
  [RelativeDateRange.LAST_YEAR]: [
    startOfYear(subYears(new Date(), 1)),
    endOfYear(subYears(new Date(), 1)),
  ],
  [RelativeDateRange.THIS_YEAR]: [
    startOfYear(new Date()),
    endOfDay(new Date()),
  ],
  [RelativeDateRange.LAST_365_DAYS]: [
    subDays(new Date(), 365),
    endOfDay(new Date()),
  ],
  [RelativeDateRange.LAST_30_DAYS]: [
    subDays(new Date(), 30),
    endOfDay(new Date()),
  ],
};

function getTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

function isDateRange(value: unknown): value is [Date, Date] {
  return (
    Array.isArray(value) &&
    value.length === 2 &&
    value[0] instanceof Date &&
    value[1] instanceof Date
  );
}

export { getTimezone, isDateRange, relativeDateLookup };
